<template>
  <div class="main-container">
    <breadcrumb :list="breadcrumbList" />
    <tl-header type="h1" class="margin-t-m">
      <div class="main-header">Statutory Deduction Override</div>
    </tl-header>

    <div class="permission-alert-msg" v-show="!ifTeamleaderAnchorPermission">
      You have only view permission.
    </div>

      <div class="row margin-t-m" :disabled="!ifTeamleaderAnchorPermission">
        <div class="col-12">
          <search-dropdown
            label="Search Employee name/code"
            :employeeData="searchEmployeeList"
            @getList="searchEmployeesByName($event)"
            @empselected="(emp)=>selectedEmp(emp)"
            @clear="resetSearch()"
          />
        </div>
      </div>
      <div class="margin-t-s" :disabled="!ifTeamleaderAnchorPermission">
        <data-table :columns="columnNames" :tableData="employeeData" :showinrow="false">
          <template v-slot:rowcontent="slotprops">
            <img
              class="sm-img text-center"
              v-if="slotprops.value.column.key=='imgSrc'"
              :src="slotprops.value.record[slotprops.value.column.key]"
            />
            <p
              v-if="slotprops.value.column.key!='imgSrc'"
            >{{slotprops.value.record[slotprops.value.column.key]}}</p>
            <a
              class="link"
              href="javascript:void(0)"
              v-if="slotprops.value.column.key=='action'"
              @click="override(slotprops.value.record)"
            >Override</a>
          </template>
        </data-table>
      </div>

    <bottom-action-container>
      <template slot="end">
        <btn-grp>
          <btn text="Back" type="secondary" @click="back" />
          <btn text="Upload" v-if="uploadMethod != 'manualUpload'" type="primary" />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>


<script>
import SearchDropdown from "@/components/TlSearchDropdown.vue";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  components: {
    SearchDropdown
  },
  data() {
    return {
      uploadMethod: "manualUpload",
      paygroup: "",
      subCriteriaLabel: "Sub Criteria",
      subCriteria: "",
      criteria: "",
      criteriaList: ["Location", "Cost Centre", "Band", "Grade", "Designation"],
      subCriteriaList: [],
      paygroupList: [],
      searchEmployeeList: [],
      breadcrumbList: [
        {
          name: "Payroll",
          url: `/dashboard/${this.$route.params.entity_index}/payroll`
        },
        {
          name: "Utilities",
          url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities`
        },
        {
          name: "Statutory Deduction Override",
          url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/statutory_deduction`
        }
      ],
      columnNames: [
        {
          label: "",
          key: "imgSrc"
        },
        {
          label: "Code",
          key: "code"
        },
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Department",
          key: "department"
        },
        {
          label: "Email ID",
          key: "email_id"
        },
        {
          label: "Location",
          key: "location"
        },
        {
          label: "Actions",
          key: "action"
        }
      ],
      employeeData: [
        {
          imgSrc: require("@/assets/user.svg"),
          code: "TL001",
          name: "Nelle Foster",
          department: "KJHG",
          email_id: "Roxie.Schmidt@gmail.com",
          location: "South Sigmund",
          datatable: ""
        }
      ],
      statutoryDeductionValue: false,
      role: ""
    };
  },
  activated() {
    this.getPaygroups();
    this.getOrgLeIdList();
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    ...mapState("onboard/organization", {
      orgId: state => state.id
    }),
    ifTeamleaderAnchorPermission() {
        if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
          if(this.statutoryDeductionValue) {
            return true;
          } else {
            return false;
          }
        } 
        // else {
        // return true 
        // }
    }
  },
  methods: {
    ...mapActions({
      fetch_paygroups: "onboard/paygroup/fetchAll",
      fetch_locations: "onboard/locations/fetchAll",
      fetch_grades: "onboard/salary_grades/fetchAll",
      fetch_bands: "onboard/salary_bands/fetchAll",
      fetch_businessunits: "onboard/business_units/fetchAll",
      fetch_cost_center: "onboard/cost_centres/fetchAll",
      fetch_designation: "onboard/designations/fetchAll",
      fetchEmployees: "globalapi/globalemployees/fetchAll",
      fetchEmployeeByName: "globalapi/globalemployees/fetchByName"
    }),
    override(record) {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/override_deduction`,
        query: { emp: record }
      });
    },
    back() {},
    backToUploadPage() {},
    async getLocations() {
      try {
        let res = await this.fetch_locations(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getBands() {
      try {
        let res = await this.fetch_bands(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getPaygroups() {
      try {
        let res = await this.fetch_paygroups(this.le_id);
        if (res.data.status) {
          this.paygroupList = res.data.payload.data;
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getDepartment() {
      try {
        let res = await this.fetch_businessunits(
          this.orgData ? this.orgData.id : ""
        );
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getCostCenter() {
      try {
        let res = await this.fetch_cost_center(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getDesignations() {
      try {
        let res = await this.fetch_designation(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getGrades() {
      try {
        let res = await this.fetch_grades(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        //console.log(error);
      }
    },
    onSelectCriteria(event) {
      this.subCriteria = "";
      if (event == "Location") {
        this.subCriteriaLabel = "Location";
        this.getLocations();
      } else if (event == "Cost Centre") {
        this.subCriteriaLabel = "Cost Centre";
        this.getCostCenter();
      } else if (event == "Band") {
        this.subCriteriaLabel = "Band";
        this.getBands();
      } else if (event == "Grade") {
        this.subCriteriaLabel = "Grade";
        this.getGrades();
      } else if (event == "Designation") {
        this.subCriteriaLabel = "Designation";
        this.getDesignations();
      } else {
        this.subCriteriaLabel = "Sub Criteria";
      }
    },
    applyFilter() {
      let obj = {};
      if (this.subCriteriaLabel == "Location") {
        obj = {
          paygroup_id: this.paygroup.id,
          location_id: this.subCriteria.id
        };
      } else if (this.subCriteriaLabel == "Cost Centre") {
        obj = {
          paygroup_id: this.paygroup.id,
          cost_centre_id: this.subCriteria.id
        };
      } else if (this.subCriteriaLabel == "Band") {
        obj = {
          paygroup_id: this.paygroup.id,
          band_id: this.subCriteria.id
        };
      } else if (this.subCriteriaLabel == "Grade") {
        obj = {
          paygroup_id: this.paygroup.id,
          grade_id: this.subCriteria.id
        };
      } else if (this.subCriteriaLabel == "Designation") {
        obj = {
          paygroup_id: this.paygroup.id,
          designation_id: this.subCriteria.id
        };
      }
      //console.log(obj);
    },
    async searchEmployeesByName(val) {
      try {
        let res = await this.fetchEmployeeByName(val);
        this.searchEmployeeList = res.data.payload.data;
      } catch (error) {
        //console.log(error);
      }
    },

    selectedEmp(obj) {
      //console.log(obj);
      this.employeeData = [obj];
    },
    resetSearch() {
      this.employeeData = [];
    },

   ...mapActions({
        getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    async getOrgLeIdList() {
        const org = this.orgId;
        const le = this.leId;
        //console.log("Org:",org);
        //console.log("Le ID",le);
        let bodyParams = {};
        let  data = await this.getOrgLeList({
          data: {
            ...bodyParams
          }
        });
        this.role = data.data.user.userRole;
        this.statutoryDeductionValue = data.data.user.permissions.statutory_deduction ? true : false;
        //console.log("PL-3406",data);
    }
  }
};
</script>

<style lang="scss" scoped>
.link {
  font-size: 14px;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
